export const environment = {
  production: true,
  i18nPrefix: '',
  configFile: 'assets/config/config.json',
  defaultConfigFile: 'assets/default/config/config.json',
  domain: undefined
};
